<template>
  <div class="container">
    <div class="container-tab yangtao">
      <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人信息">
        </el-tab-pane>
        <el-tab-pane label="我的积分">
        </el-tab-pane>
        <el-tab-pane label="兑换记录">
        </el-tab-pane>
        <!-- 兑换记录  内 部用户不显示上面的 -->
        <el-tab-pane label="兑换记录">
        </el-tab-pane>
        <!-- 兑换记录  外 部用户都显示 -->
        <el-tab-pane label="我的学习">
        </el-tab-pane>
        <el-tab-pane label="学习提醒">
        </el-tab-pane>
        <el-tab-pane label="资料中心">
        </el-tab-pane>
        <el-tab-pane label="我的会议">
        </el-tab-pane>
        <el-tab-pane label="我的提问">
        </el-tab-pane>
        <el-tab-pane>
          <el-badge :value="msgNum" :max="99" style="" :hidden="!msgNum" slot="label">
            <span>我的消息</span>
          </el-badge>
        </el-tab-pane>
        <el-tab-pane label="意见反馈">
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getMessageNumber } from '@/api/course'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      activeName: '0'
    };
  },
  computed: {
    ...mapState({
      msgNum: state => state.user.msgNum
    }),
    userInfo() {
      return this.$store.getters.userInfo
    },
    activeTab() {
      return this.$store.getters.activeTab
    }
  },
  watch:{
    activeTab(val,oldVal) {
      this.activeName = this.activeTab
    }
  },
  mounted() {
    this.activeName = this.activeTab
    this.handleGetMsgNum()
  },
  methods: {
    handleGetMsgNum() {
      this.$store.dispatch('user/getMsgNum')
    },
    handleClick(tab, event) {
      console.log(tab.index);
      switch (tab.index) {
        case '0':
          this.navToPersonInfo()
          break
        case '1':
          this.navToScore()
          break
        case '3':
          this.navToExchangeRecord()
          break
        case '4':
          this.navToMyStudy()
          break
        case '5':
          this.navToStudyRemind()
          break
        case '6':
          this.navToDataCenter()
          break
        case '7':
          this.navToMyMeeting()
          break
        case '8':
          this.navToMyQuestion()
          break
        case '9':
          this.handleGetMsgNum()
          this.navToMyMessage()
          break
        case '10':
          this.navToFeedback()
          break
      }
    },
    navToPersonInfo() {
      this.$router.push({ path: '/person-info'})
    },
    navToScore() {
      this.$router.push({ path: '/score'})
    },
    navToExchangeRecord() {
      this.$router.push({ path: '/exchange-record'})
    },
    navToMyStudy() {
      this.$router.push({ path: '/my-study'})
    },
    navToStudyRemind() {
      this.$router.push({ path: '/study-remind'})
    },
    navToDataCenter() {
      this.$router.push({ path: '/data-center'})
    },
    navToMyMeeting() {
      this.$router.push({ path: '/my-meeting'})
    },
    navToMyQuestion() {
      this.$router.push({ path: '/my-question'})
    },
    navToMyMessage() {
      this.$router.push({ path: '/my-message'})
    },
    navToFeedback() {
      this.$router.push({ path: '/feedback'})
    },
  }
}
</script>
<style lang="scss" scoped>
.container{
  &-tab{
    // margin-top: 1rem;
    // padding-top: 1.32rem;
    // background: #ffffff;
    // width: 62.69rem;
    // height: 35.63rem;

    &.forRecordShow{
      /deep/ .el-tabs{
        #tab-2{
          display: flex;
        }
      }
    }

    /deep/ .el-tabs{
      width: 100%;
      height: 100%;

      .el-badge__content{
        top: 18px;
        right: -5px;
      }

      #tab-2{
        display: none;
      }

      .el-tabs__item{
        font-size: 0.88rem;
        font-weight: Regular;
        padding-left: 3.13rem;
        width: 13rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
      }
      .el-tabs__item:hover{
        color: #07A905;
      }
      .el-tabs__item.is-active{
        color: #07A905;
        background: rgba(7,169,3,0.3);
      }
      .el-tabs__nav-wrap::after{
        display: none;
      }
      .el-tabs__active-bar{
        background: #07A905;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserCenterTab.vue